export const useUserSettingsPending = () => {
  const route = useRoute();
  const { isAuthenticated } = storeToRefs(useAuthStore());

  function clearHighlightQueryParam() {
    const query = { ...route.query };

    delete query.highlight;

    return navigateTo({
      query,
      replace: true,
    });
  }

  function updateHighlightQueryParam(highlight: string) {
    const query = { ...route.query };

    query.highlight = highlight;

    return navigateTo({
      query,
      replace: true,
    });
  }

  async function checkPending(refsForPendencyList: any) {
    // Bug real: os campos da página de conta (Documento, Endereço, etc.)
    // emitem check-pendency reativamente quando seus próprios dados mudam
    // — inclusive quando o logout reseta as stores (userData/kyc). Sem
    // esse guard, isso chama navigateTo() (replace na rota atual) bem no
    // meio do redirect pra home do logout, cancelando a navegação real
    // (ver stores/auth.ts isRedirectingHome). Não faz sentido gerenciar
    // "highlight" de pendência pra um usuário já deslogado de qualquer forma.
    if (!isAuthenticated.value) {
      return;
    }

    const { isWithinMigrationPeriod } = useFeatureFlagsNew();
    const { redirectToPendingSettings } = useUserValidations();

    const getPendencyList = refsForPendencyList.filter((item: any) => {
      return item?.hasPendency;
    });

    if (!getPendencyList.length) {
      clearHighlightQueryParam();

      if (isWithinMigrationPeriod.value) {
        await redirectToPendingSettings();
      }

      return;
    }

    // @ts-ignore
    const currentEditing = getPendencyList.find(({ isEditing }) => !!isEditing);

    if (currentEditing) {
      return updateHighlightQueryParam(currentEditing.name);
    }

    const currentHighlight = getPendencyList.find(
      // @ts-ignore
      ({ name }) => name === route.query.highlight,
    );

    if (currentHighlight?.hasPendency) {
      return;
    }

    const [currentPending] = getPendencyList;

    if (!currentPending) {
      return;
    }

    if (!currentPending.isEditing) {
      currentPending.toggleEdit();
    }

    return updateHighlightQueryParam(currentPending.name);
  }

  return {
    checkPending,
  };
};
